import compact from 'lodash.compact';
import { BASE_URLS, SS_URL, URL, getMainHelpUrl } from '../../constants/reading/ApiConstants';
import { PERIOD } from '../../constants/shared/CommonConstants';
import { LICENSE } from '../../constants/reading/CommonConstants';

const { BENCHMARK_URL } = BASE_URLS;
const { EXPRESS_HELP_URL } = URL.EXPRESS;
const { BENCHMARK_HISTORY, TRC_SUMMARY, PROGRESS } = SS_URL;
const { TRC, EXPRESS, D8 } = LICENSE;
const { SUMMARY } = PERIOD;

const getExpressSummaryQuestions = (licensingInfo, selectedPeriod) =>
    licensingInfo.includes(EXPRESS)
        ? [
              {
                  title: 'How does Text Reading Online (TRO) measure reading accuracy, fluency, and comprehension?',
                  url: `${EXPRESS_HELP_URL}TRO_Over`,
                  accessiblePages: [BENCHMARK_URL],
              },
              {
                  title: 'How does Decoding Online (DO) measure a student’s decoding skills?',
                  url: `${EXPRESS_HELP_URL}DO_Over`,
                  accessiblePages: [BENCHMARK_URL],
              },
              selectedPeriod === SUMMARY
                  ? {
                        title: 'What research was used to develop the mCLASS Express measures?',
                        url: `${EXPRESS_HELP_URL}ME_Research`,
                        accessiblePages: [BENCHMARK_URL],
                    }
                  : {
                        title: 'How can I use mCLASS Express results for small group instruction?',
                        url: `${EXPRESS_HELP_URL}I_G`,
                        accessiblePages: [BENCHMARK_URL],
                    },
              {
                  title: 'How can I use mCLASS Express for one-on-one instruction?',
                  url: `${EXPRESS_HELP_URL}I_S`,
                  accessiblePages: [BENCHMARK_HISTORY],
              },
              {
                  title: 'What do the TRO Proficiency Levels mean?',
                  url: `${EXPRESS_HELP_URL}TRO_PL`,
                  accessiblePages: [BENCHMARK_HISTORY],
              },
          ]
        : [];

const geTrcSummaryQuestions = (licensingInfo, helpUrlWithTrc) =>
    licensingInfo.includes(TRC)
        ? [
              {
                  title: 'Understanding the Text Reading History',
                  url: `${helpUrlWithTrc}SS_TRC`,
                  accessiblePages: [TRC_SUMMARY],
              },
              {
                  title: 'How is the TRC reading level determined?',
                  url: `${helpUrlWithTrc}TRC_PL_RL`,
                  accessiblePages: [TRC_SUMMARY],
              },
              {
                  title: 'What is the difference between a reading level and a proficiency level?',
                  url: `${helpUrlWithTrc}TRC_PL_CS`,
                  accessiblePages: [TRC_SUMMARY],
              },
          ]
        : [];

const getSummaryQuestions = (licensingInfo, selectedPeriod, helpUrlWithTrc, isSecure = false) =>
    licensingInfo.includes(D8)
        ? [
              {
                  title: 'How are DIBELS Composite Scores calculated?',
                  url: `${helpUrlWithTrc}CS_Calc`,
                  accessiblePages: [BENCHMARK_URL],
              },
              {
                  title: 'What is this student’s DIBELS benchmark history?',
                  url: `${helpUrlWithTrc}SS_BH`,
                  accessiblePages: [BENCHMARK_HISTORY],
              },
              selectedPeriod !== SUMMARY && {
                  title: 'Why are some DIBELS measures Discontinued or Tested Out?',
                  url: `${helpUrlWithTrc}Gating`,
                  accessiblePages: [BENCHMARK_URL, BENCHMARK_HISTORY],
              },
              {
                  title: 'Where can I find the DIBELS 8th Edition research document?',
                  url: `${helpUrlWithTrc}SC`,
                  accessiblePages: [BENCHMARK_URL],
              },
              {
                  title: 'How are DIBELS benchmark goals determined?',
                  url: `${helpUrlWithTrc}BG`,
                  accessiblePages: [BENCHMARK_HISTORY],
              },
              selectedPeriod !== SUMMARY && {
                  title: 'How do I show and interpret DIBELS percentiles?',
                  url: `${helpUrlWithTrc}BCS_TOY_P`,
                  accessiblePages: [BENCHMARK_URL],
              },
              selectedPeriod === SUMMARY && {
                  title: 'How do I show and interpret Composite Score percentiles?',
                  url: `${helpUrlWithTrc}BCS_P`,
                  accessiblePages: [BENCHMARK_URL],
              },
              isSecure && {
                  title: 'What does the E (Equated) icon next to a composite score mean?',
                  url: `${helpUrlWithTrc}CS_ES`,
                  accessiblePages: [BENCHMARK_URL],
              },
          ]
        : [];

const getAvailibleQuestions = (licensingInfo, selectedPeriod, isSecure) => {
    const helpUrlWithTrc = getMainHelpUrl(licensingInfo);
    const expressSummaryQuestions = getExpressSummaryQuestions(licensingInfo, selectedPeriod);
    const trcSummaryQuestions = geTrcSummaryQuestions(licensingInfo, helpUrlWithTrc);
    const summaryQuestions = getSummaryQuestions(
        licensingInfo,
        selectedPeriod,
        helpUrlWithTrc,
        isSecure,
    );

    return compact([
        ...summaryQuestions,
        {
            title: 'Understanding the Student Summary Progress Monitoring report',
            url: `${helpUrlWithTrc}SS_PM`,
            accessiblePages: [PROGRESS],
        },
        ...expressSummaryQuestions,
        ...trcSummaryQuestions,
    ]);
};

export default getAvailibleQuestions;
